module.exports = __webpack_public_path__ + "img/red-money-icon.2e0c3044.svg";